<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row" v-if="isLease == false">
      <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/2 mb-base">
        <statistics-card-line
          hideChart 
          class="mb-base" 
          icon="DollarSignIcon"
          icon-right
          :statistic="totalOrder"
          statisticTitle="Total Geral"
          :color="color"
        />
      </div>
    </div>
    <div class="vx-row" v-if="stages">
      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="SearchIcon"
          icon-right
          :statistic="stages.conference"
          statisticTitle="Conferência"
          :color="color"
        />
      </div>

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="PackageIcon"
          icon-right
          :statistic="stages.stock"
          statisticTitle="Estoque"
          :color="color"
        />
      </div>
      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="stages.revenues"
          statisticTitle="Faturamento"
          :color="color"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { numberJS } from "@/helpers";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      totalOrder: 0,
      stages: null,
      color: null,
      isLease: false,
    };
  },
  methods: {
    calculateOrders(orders, color) {
      this.color = color;
      let total = 0;
      let sumOrders = [];
      for (let order of orders) {
        let totalOrder = order.totalOrder;
        sumOrders.push(totalOrder);
      }

      total = 0;
      for (let order of sumOrders) {
        total += numberJS().getNumber(order);
      }
      this.totalOrder = numberJS().formatBRL(total);
    },
    showPercentageStage(orders, color) {
      this.color = color;
      let stages = {};
      let conference = 0;
      let stock = 0;
      let revenues = 0;
      let concluded = 0;

      for (let order of orders) {
        if (order.stage == "Conferência") {
          conference++;
        }
        if (order.stage == "Estoque") {
          stock++;
        }
        if (order.stage == "Faturamento") {
          revenues++;
        }
        if (order.stage == "Concluído") {
          concluded++;
        }
      }

      let totalStages = conference + stock + revenues + concluded;
      let percConference = (conference * 100) / totalStages;
      let percStock = (stock * 100) / totalStages;
      let percRevenues = (revenues * 100) / totalStages;
      let percConcluded = (concluded * 100) / totalStages;

      stages.conference = numberJS().formatPercent(percConference) + "%";
      stages.stock = numberJS().formatPercent(percStock) + "%";
      stages.revenues = numberJS().formatPercent(percRevenues) + "%";
      stages.concluded = numberJS().formatPercent(percConcluded) + "%";
      this.stages = stages;
    },
  },
  created() {
    if (this.$router.currentRoute.path == "/ouro") {
      this.isLease = true;
    } else if (this.$router.currentRoute.path == "/suprimentos-locacao") {
      this.isLease = true;
    } else {
      this.isLease = false;
    }
  },
  mounted() {},
};
</script>
